









import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { PostRequest } from '@/store/requeststate';
import { BookmarkBean } from '@/types';

@Component({})
export default class Bookmark extends Vue {
    @Action('post', {namespace: 'requestState'})
    public post!: (req: PostRequest) => Promise<any>;

    @Prop()
    private bookmark!: BookmarkBean;

    private async incrementAccessCount() {
        await this.post({path: 'api/bookmark/increment', params: {}, data: {
                bookmarkId: this.bookmark.bookmarkId,
            },
        });
    }
}
